export default "__VITE_ASSET__wSadzqqx__"